import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  useFormikSelectFieldGetEmptyValue,
} from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  CREATE_CHECKLIST_FIELD_NAME_TEMPLATE,
  CREATE_CHECKLIST_FIELD_NAME_TITLE,
  REQUEST_PROFILE_TAB_INTERNAL_TASKS_NAME_MAX_LENGTH,
} from '../../RequestProfileTabInternalTasks.constants'
import { RequestProfileTabInternalTasksTemplateSelect } from '../../RequestProfileTabInternalTasksTemplateSelect'

function FormFields() {
  const { t } = useTranslation()

  const templateEmptyValue = useFormikSelectFieldGetEmptyValue(EMPTY_OBJECT)

  return (
    <FormFieldsContainer>
      <FormikField
        borderless
        hasCounter
        Component={InputField}
        fieldComponentProps={{
          label: `${t('RequestProfile.InternalTasksTitleFieldLabelKey')}:`,
          required: true,
        }}
        maxLength={REQUEST_PROFILE_TAB_INTERNAL_TASKS_NAME_MAX_LENGTH}
        name={CREATE_CHECKLIST_FIELD_NAME_TITLE}
        placeholder={t('RequestProfile.InternalTasksTitleFieldPlaceholderKey')}
      />
      <FormikField
        Component={FormFieldSelectNG}
        Select={RequestProfileTabInternalTasksTemplateSelect}
        controlProps={{
          borderless: true,
          contentProps: {
            inputProps: {
              placeholder: t(
                'RequestProfile.InternalTasksTemplateFieldPlaceholderKey'
              ),
            },
          },
        }}
        emptyValue={templateEmptyValue}
        fieldComponentProps={{
          label: `${t('RequestProfile.InternalTasksTemplateFieldLabelKey')}:`,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        name={CREATE_CHECKLIST_FIELD_NAME_TEMPLATE}
      />
    </FormFieldsContainer>
  )
}

export default FormFields
